<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('luckyDrawAvailableItem.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('luckyDrawAvailableItem.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :expandable="true"
      >
        <template v-slot="{ record }">
          <td>{{ record.event_name }}</td>
          <td>{{ record.event_start_date }}</td>
          <td>{{ record.event_end_date }}</td>
          <td>
            {{
              record.fee_amount +
              ' ' +
              (record.curreny ? record.curreny.currency_code : '')
            }}
          </td>
          <td class="text-center">
            <a-switch
              :loading="loading"
              v-model="record.is_active"
              size="small"
              @change="onIsActiveChange(record)"
            />
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <!-- close delete -->
            <a
              v-if="false"
              href="#"
              class="text-danger"
              v-tooltip="$t('delete')"
              @click="onDelete(record)"
              :disabled="record._deleting"
            >
              <i
                class="fas fa-circle-notch fa-spin"
                v-if="record._deleting"
              ></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </td>
        </template>
        <div slot="expand" slot-scope="prop">
          <table class="ts-w-11/12 ts-mx-auto detail">
            <thead>
              <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                <th class="ts-pl-2 ts-whitespace-nowrap">
                  {{ $t('luckyDrawAvailableItem.itemNameEn') }}
                </th>
                <th class="ts-pl-2 ts-whitespace-nowrap">
                  {{ $t('luckyDrawAvailableItem.itemNameKh') }}
                </th>
                <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                  {{ $t('luckyDrawAvailableItem.quantity') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="ts-border-b-2"
                v-for="(detail, index) in prop.record.item_list"
                :key="index"
              >
                <td class="ts-p-2 ts-whitespace-nowrap">
                  {{ detail.item_name_en }}
                </td>
                <td class="ts-p-2 ts-whitespace-nowrap">
                  {{ detail.item_name_kh }}
                </td>
                <td class="ts-p-2 ts-whitespace-nowrap ts-text-center">
                  {{ detail.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('luckyDrawAvailableItem.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="650px"
      >
        <from-action @cancel="clearEdit" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'companyIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('luckyDraw/luckyDrawAvailableItem', [
      'resources',
      'pagination'
    ]),
    search: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawAvailableItem.search
      },
      set (newValue) {
        this.$store.commit(
          'luckyDraw/luckyDrawAvailableItem/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'luckyDraw/luckyDrawAvailableItem/RESET_CURRENT_PAGE'
        )
      }
    },
    columns () {
      return [
        { name: this.$t('luckyDrawAvailableItem.eventName') },
        { name: this.$t('luckyDrawAvailableItem.eventStartDate') },
        { name: this.$t('luckyDrawAvailableItem.eventEndDate') },
        { name: this.$t('luckyDrawAvailableItem.feeAmount') },
        {
          name: this.$t('luckyDrawAvailableItem.isActive'),
          style: 'text-align:center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    photo (record) {
      if (record.photo) {
        return record.photo
      }
      return require('@/assets/default-product_flat.jpg')
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('luckyDraw/luckyDrawAvailableItem/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit(
        'luckyDraw/luckyDrawAvailableItem/SET_EDIT_DATA',
        record
      )
      this.showForm = true
    },
    async onIsActiveChange (record) {
      this.loading = true
      this.$store
        .dispatch('luckyDraw/luckyDrawAvailableItem/changeIsActive', {
          id: record.id,
          data: record
        })
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          record.is_active = !record.is_active
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onDelete (record) {
      record._deleting = true
      this.$store
        .dispatch('luckyDraw/luckyDrawAvailableItem/destroy', record.id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          record._deleting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
    },
    clearEdit () {
      this.$store.commit('luckyDraw/luckyDrawAvailableItem/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('luckyDraw/luckyDrawAvailableItem/RESET_STATE')
    next()
  }
}
</script>
